// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"401e4bfe","63":"cc3d4be5","207":"cbc76388","279":"856b65e9","610":"624f34c9","685":"31d6cfe0","960":"bbfbd893","976":"070ed9b2"}[chunkId] + ".chunk.css";
};